module.exports = __webpack_public_path__ + "media/offers_icons/liczba-drzwi-bda45866.svg";